<template>
  <div id="tabcreate" style="
      background-color: #fff;
      border: 1px solid #e0e0e0;
      border-top: 0px;
      border-radius: 0 0 3px 3px;
      padding-top: 12px;
    ">
    <div class="margin-subpages">
      <div class="flex-center">
        <div class="fs-18 fw-700">{{ $t("powerUp.Preset_Library") }}</div>
        <div class="ml-auto mr-18 flex-center">
          <img :src="$utils('icons', 'ic_bolt_purple_24dp')" style="height: 18px" alt="icons_ic_bolt_purple_24dp" />{{
            countAuto }} {{ $t("powerUp.Automations") }}
        </div>
      </div>
      <div v-if="loadingPresetLibrary" class="powerup-table">
        <div v-for="dataMock in [1, 2, 3, 4, 5, 6, 7, 8, 9]" :key="'card_mock_library_' + dataMock"
          :class="`powerup-card ${dataMock % 3 ? 'mr-20' : ''} opa-0${10 - dataMock}`">
          <div>
            <div class="cover-image flex-mid fc-FFFFFF image-skeleton">
              <i class="el-icon-picture-outline opa-04 fs-32"></i>
            </div>
          </div>
          <div class="px-6">
            <div class="card-title mt-16 text-skeleton" style="width: 140px">
              &nbsp;
            </div>
            <div class="mt-20">
              <div class="text-skeleton fs-14" style="width: 80px">&nbsp;</div>
            </div>
            <div class="mt-6">
              <div class="text-skeleton fs-14" style="width: 80px">&nbsp;</div>
            </div>
            <div class="mt-6">
              <div class="text-skeleton fs-14" style="width: 40px">&nbsp;</div>
            </div>
          </div>
        </div>
        <div style="height: 300px"></div>
      </div>
      <div v-else class="powerup-table">
        <div v-for="(data, index) in presentLibrary" :key="'card_present_library_' + index"
          :class="`powerup-card ${(index + 1) % 3 ? 'mr-20' : ''}`">
          <div>
            <img v-if="data.image" v-lazy="require(`@/assets/images/powerups/${data.image}.png`)"
              class="cover-image image-skeleton" alt="Library Image" />
            <div v-else class="cover-image flex-mid fc-FFFFFF">
              <i class="el-icon-picture-outline opa-04 fs-32"></i>
            </div>
          </div>
          <div class="px-6">
            <div class="card-title mt-16">{{data ? (data.label === 'Active Managers' ? 'Responsive Managers' : data.label) : ''}}</div>
            <div v-if="data.label=='Birthday'||data.label=='Work Anniversary'" class="card-title mt-5">{{data?data.label_2:'' }}</div>


            <div v-if="data.label=='Birthday'||data.label=='Work Anniversary'" class="" style="padding-top: 42px;" >
              <el-dropdown trigger="click" @command="handleClickDropdown" :hide-on-click="false">
                <div class="el-dropdown-link flex-center">
                  <div class="mt-2">Same day</div>
                  <img v-if="data.autoDay.status" :src="$utils('icons', 'ic_bolt_purple_24dp')" style="height: 18px"
                    alt="icons_ic_bolt_purple_24dp" />
                  <div class="ml-auto"><i class="el-icon-arrow-right"></i></div>
                </div>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item :command="{
                    path: data.path,
                    menuList: day.label,
                    type: data.label,
                    typeList: 'day',
                    edit: false,
                  }" v-for="day in data.day" :key="'dropdown_' + index + day.label" :disabled="day.status">
                    <div class="flex-center">
                      <div>{{ day.label }}</div>
                      <div class="ml-auto"><i class="el-icon-plus"></i></div>
                    </div>
                  </el-dropdown-item>
                  <el-dropdown-item :command="{
                    type: data.label,
                    typeList: 'day',
                    status_disable: data.autoDay.status ? 'disable_' + data.autoDay.status : 'disable_false',
                    path: data.path,
                    auto: data.autoDay
                  }" style="background-color: #6c30cc19; padding: 4px 16px">
                    <div v-if="data.autoDay.status" class="flex-center fs-13 fw-700 fc-6C30CC">
                      <img style="height: 24px" alt="icons_ic_bolt_black_24dp"
                        :src="$utils('icons', 'ic_bolt_purple_24dp')" />
                      {{ $t("powerUp.Automate") }}
                      <img class="ml-auto" :src="getImgUrlPowerups('ic_toggle_on')" alt="ic_toggle_on" />
                    </div>
                    <div v-else class="flex-center fs-13 fw-700 fc-000000">
                      <img :src="$utils('icons', 'ic_bolt_black_24dp')" style="height: 18px"
                        alt="icons_ic_bolt_purple_24dp" />

                      {{ $t("powerUp.Automate") }}
                      <img class="ml-auto" :src="getImgUrlPowerups('ic_toggle_off')" alt="ic_toggle_off" />
                    </div>
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </div>


            <div v-else>
            <div class="mt-14">
              <el-dropdown trigger="click" @command="handleClickDropdown" :hide-on-click="false">
                <div class="el-dropdown-link flex-center">
                  <div class="mt-2">{{ $t("powerUp.By_Month") }}</div>
                  <img v-if="data.autoMonth.status" :src="$utils('icons', 'ic_bolt_purple_24dp')" style="height: 18px"
                    alt="icons_ic_bolt_purple_24dp" />
                  <div class="ml-auto"><i class="el-icon-arrow-right"></i></div>
                </div>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item v-for="month in data.month" :key="'dropdown_' + index + month.label" :command="{
                    menuList: month.label,
                    type: data.label,
                    typeList: 'month',
                    path: data.path,
                  }">
                    <div class="flex-center">
                      <div>{{ month.label }}</div>
                      <div class="ml-auto"><i class="el-icon-plus"></i></div>
                    </div>
                  </el-dropdown-item>
                  <el-dropdown-item :command="{
                    type: data.label,
                    typeList: 'month',
                    status_disable: data.autoMonth.status ? 'disable_' + data.autoMonth.status : 'disable_false',
                    path: data.path,
                    auto: data.autoMonth
                  }" style="background-color: #6c30cc19; padding: 4px 16px">
                    <div v-if="data.autoMonth.status" class="flex-center fs-13 fw-700 fc-6C30CC">
                      <img style="height: 24px" alt="icons_ic_bolt_black_24dp"
                        :src="$utils('icons', 'ic_bolt_purple_24dp')" />
                      {{ $t("powerUp.Automate") }}
                      <img class="ml-auto" :src="getImgUrlPowerups('ic_toggle_on')" alt="ic_toggle_on" />
                    </div>
                    <div v-else class="flex-center fs-13 fw-700 fc-000000">
                      <img :src="$utils('icons', 'ic_bolt_black_24dp')" style="height: 18px"
                        alt="icons_ic_bolt_purple_24dp" />

                      {{ $t("powerUp.Automate") }}
                      <img class="ml-auto" :src="getImgUrlPowerups('ic_toggle_off')" alt="ic_toggle_off" />
                    </div>
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </div>
            <div class="">
              <el-dropdown trigger="click" @command="handleClickDropdown" :hide-on-click="false">
                <div class="el-dropdown-link flex-center">
                  <div class="mt-2">{{ $t("powerUp.By_Quarter") }}</div>
                  <img v-if="data.autoQuarter.status" :src="$utils('icons', 'ic_bolt_purple_24dp')" style="height: 18px"
                    alt="icons_ic_bolt_purple_24dp" />
                  <div class="ml-auto"><i class="el-icon-arrow-right"></i></div>
                </div>
                <el-dropdown-menu slot="dropdown" style="box-shadow: 0px 3px 12px #00000052">
                  <el-dropdown-item :command="{
                    menuList: quarter.label,
                    type: data.label,
                    typeList: 'quarter',
                    edit: false,
                    path: data.path,
                  }" v-for="quarter in data.quarter" :key="'dropdown_' + index + quarter.label">
                    <div class="flex-center">
                      <div>{{ quarter.label }}</div>
                      <div class="ml-auto"><i class="el-icon-plus"></i></div>
                    </div>
                  </el-dropdown-item>
                  <el-dropdown-item :command="{

                    type: data.label,
                    typeList: 'quarter',
                    status_disable: data.autoQuarter.status ? 'disable_' + data.autoQuarter.status : 'disable_false',
                    path: data.path,
                    auto: data.autoQuarter
                  }" style="background-color: #6c30cc19; padding: 4px 16px">
                    <div v-if="data.autoQuarter.status" class="flex-center fs-13 fw-700 fc-6C30CC">
                      <img style="height: 24px" :src="$utils('icons', 'ic_bolt_purple_24dp')"
                        alt="icons_ic_bolt_black_24dp" />
                      {{ $t("powerUp.Automate") }}
                      <img class="ml-auto" :src="getImgUrlPowerups('ic_toggle_on')" alt="ic_toggle_on" />
                    </div>
                    <div v-else class="flex-center fs-13 fw-700 fc-000000">
                      <img style="height: 18px" :src="$utils('icons', 'ic_bolt_black_24dp')"
                        alt="icons_ic_bolt_purple_24dp" />

                      {{ $t("powerUp.Automate") }}
                      <img class="ml-auto" :src="getImgUrlPowerups('ic_toggle_off')" alt="ic_toggle_off" />
                    </div>
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </div>
            <div class="">
              <el-dropdown trigger="click" @command="handleClickDropdown" :hide-on-click="false">
                <div class="el-dropdown-link flex-center">
                  <div class="mt-2">{{ $t("powerUp.By_Year") }}</div>
                  <img v-if="data.autoYear.status" :src="$utils('icons', 'ic_bolt_purple_24dp')" style="height: 18px"
                    alt="icons_ic_bolt_purple_24dp" />
                  <div class="ml-auto"><i class="el-icon-arrow-right"></i></div>
                </div>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item :command="{
                    path: data.path,
                    menuList: year.label,
                    type: data.label,
                    typeList: 'year',
                    edit: false,
                  }" v-for="year in data.year" :key="'dropdown_' + index + year.label" :disabled="year.status">
                    <div class="flex-center">
                      <div>{{ year.label }}</div>
                      <div class="ml-auto"><i class="el-icon-plus"></i></div>
                    </div>
                  </el-dropdown-item>
                  <el-dropdown-item :command="{
                    type: data.label,
                    typeList: 'year',
                    status_disable: data.autoYear.status ? 'disable_' + data.autoYear.status : 'disable_false',
                    path: data.path,
                    auto: data.autoYear
                  }" style="background-color: #6c30cc19; padding: 4px 16px">
                    <div v-if="data.autoYear.status" class="flex-center fs-13 fw-700 fc-6C30CC">
                      <img style="height: 24px" alt="icons_ic_bolt_black_24dp"
                        :src="$utils('icons', 'ic_bolt_purple_24dp')" />
                      {{ $t("powerUp.Automate") }}
                      <img class="ml-auto" :src="getImgUrlPowerups('ic_toggle_on')" alt="ic_toggle_on" />
                    </div>
                    <div v-else class="flex-center fs-13 fw-700 fc-000000">
                      <img :src="$utils('icons', 'ic_bolt_black_24dp')" style="height: 18px"
                        alt="icons_ic_bolt_purple_24dp" />

                      {{ $t("powerUp.Automate") }}
                      <img class="ml-auto" :src="getImgUrlPowerups('ic_toggle_off')" alt="ic_toggle_off" />
                    </div>
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </div>
            </div>




            


            
          </div>
        </div>
      </div>
      <div class="fs-18 fw-700">{{ $t("powerUp.Create_your_own") }}</div>


      <div class="powerup-table">
        <div class="powerup-card mr-20">
          <div>
            <img v-lazy="require(`@/assets/images/powerups/Coin.png`)" class="cover-image image-skeleton"
              alt="Library Image" />
          </div>
          <div class="px-6">
            <div class="card-title mt-16">Give Coins</div>
            <div class="fs-13 opa-08 mt-2 pl-10 pr-16">Recognize positive effort & support</div>
            <div class="mt-28">
              <div @click="handleClickDropdown('Give Coins')" class="flex-center el-dropdown-link" style="color: #6c30cc">
                <div class="fs-13 fw-700">{{ $t("powerUp.Create_your_own") }}</div>
                <div class="ml-auto"><i class="el-icon-plus"></i></div>
              </div>
            </div>
          </div>
        </div>


        <div class="powerup-card  mr-20">
          <div>
            <img v-lazy="require(`@/assets/images/powerups/Gem.png`)" class="cover-image image-skeleton"
              alt="Library Image" />
          </div>
          <div class="px-6">
            <div class="card-title  mt-16">Give a Gem</div>
            <div class="fs-13 opa-08 mt-2 pl-10 pr-16">Recognize performance & results</div>
            <div class="mt-28">
              <div @click="handleClickDropdown('Give a Gem')" class="flex-center el-dropdown-link" style="color: #6c30cc">
                <div class="fs-13 fw-700">{{ $t("powerUp.Create_your_own") }}</div>
                <div class="ml-auto"><i class="el-icon-plus"></i></div>
              </div>
            </div>
          </div>
        </div>



        <div class="powerup-card">
          <div>
            <img v-lazy="require(`@/assets/images/powerups/Medal.png`)" class="cover-image image-skeleton"
              alt="Library Image" />
          </div>
          <div class="px-6">
            <div class="card-title  mt-16">Give a Medal</div>
            <div class="fs-13 opa-08 mt-2 pl-10 pr-16">Recognize outstanding achievements</div>
            <div class="mt-28">
              <div @click="handleClickDropdown('Give a Medal')" class="flex-center el-dropdown-link"
                style="color: #6c30cc">
                <div class="fs-13 fw-700">{{ $t("powerUp.Create_your_own") }}</div>
                <div class="ml-auto"><i class="el-icon-plus"></i></div>
              </div>
            </div>
          </div>
        </div>

      </div>





    </div>
    <div class="remove-padding-modal">
      <el-dialog :visible.sync="dialogFormVisible" top="12vh" width="580px" @close="cancelDialog">
        <div class="RecipientsModalStyle">
          <div>
            <span class="fs-20 fw-700 fc-000000">{{ $t("powerUp.Power_up_Recipients") }}</span>
          </div>
          <div class="mt-24">
            <span class="fs-18 fw-700 fc-000000">{{
              $utils("addCommasInNumber", validateForm.recipientsUser.length)
            }}
              {{ $t("powerUp.recipients") }}</span>
          </div>
          <div class="mt-4">
            <span class="fc-626262 fs-14">{{ $t("powerUp.based_on_your_selection") }}</span>
          </div>
        </div>
        <div class="divMembersRecipients thin-scrollbar">
          <div v-for="item in validateForm.recipientsUser" :key="item.key" class="rowDataStyle"
          :class="[ blurMode ?  'blurelement': '' ]"
            @click="removeUserClick(item)">
            <div class="columnDataStyle" style="width: 60%">
              <div class="divProfile">
                <div v-if="item.pic">
                  <img v-lazy="item.pic" :key="item.pic" class="imgProfile flex-mid" />
                </div>
                <div v-else class="imgProfile">
                  <div class="flex-mid text-in-image" style="width: 42px" :class="[
                    `${item === 0 ? 'text-in-image-44' : 'text-in-image-32'}`,
                  ]">
                    {{
                      $utils("acronymName", {
                        firstName: item.firstname,
                        lastName: item.lastname,
                      })
                    }}
                  </div>
                </div>

                <div class="flex-column pl-16">
                  <span class="text-name">{{ item.firstname }} {{ item.lastname }}</span>
                  <span class="text-email">{{ item.email }}</span>
                </div>
              </div>
            </div>
            <div class="columnDataStyle txtEllipsis" style="width: 35%; padding: 0px">
              <span class="fs-14 fc-4A4A4A">{{ item.team_name }}</span>
            </div>
            <div class="columnDataStyle" style="width: 30px">
              <img :src="getImgUrlPowerups('ic_remove_circle@2x')" class="iconRemoveStyle" />
            </div>
          </div>
        </div>
      </el-dialog>
      <el-dialog :visible.sync="dialogCreateReward" width="982px" top="8vh" @close="cancelAdd">
        <div class="grid-2-sesstion">
          <div class="grid-left rm-scrollbar">
            <div class="header flex-center">
              <img :src="$utils('icons', 'ic_preview')" style="height: 24px; margin-top: -2px" class="mr-12" />
              <span>{{ $t("powerUp.Preview_on_Mobile_Layout") }}</span>
            </div>
            <div class="img-activityfeed relative" style="height: 855px">
              <img class="imgScreenActivityfeed" :src="getImgUrlPowerups('mobile_activity_feed_preview@2x')" />
              <!-- <div style="position: absolute; top: 37%; right: 11%">
                <img
                  class="imgEmptyFeed"
                  v-bind:style="setOpacityShareCheck(validateForm.share)"
                  :src="getImgUrlPowerups('empty_activityfeed_row@2x')"
                />
              </div> -->
              <div class="hashtag-contriner">
                <div class="flex-center hashtag-inner">
                  <div class="hashtag" v-for="tags in valuesOptional" :key="tags.value + '_showtag_mobile'">
                    {{ tags.label }}
                  </div>
                </div>
              </div>

              <div class="divEmptyFeed" :style="`top: ${valuesOptional.length > 0 ? '45' : '44'
                }%; setOpacityShareCheck(validateForm.share)`">
                <div class="card">
                  <div class="card-inner flex-center">
                    <div class="user-profile"></div>
                    <div class="text mr-auto">
                      <span class="fw-700"
                      :class="[ blurMode ?  'blurelement': '' ]">{{
                        validateForm.txtName
                        ? validateForm.txtName
                        : $t('powerUp.Name_of_Recipient')
                      }}</span>&nbsp; <span>{{ $t("powerUp.got") }}</span>&nbsp;
                      <span class="fw-700">{{
                        this.validateForm.txtReward
                        ? this.validateForm.txtReward
                        : $t('powerUp.Reward')
                      }}</span>&nbsp; <span class="">{{ $t("powerUp.for") }}</span>&nbsp;
                      <span class="italic">{{
                        mockingMobileTextFor(validateForm.for || '')
                      }}</span>
                      <span class="tags italic" v-for="(tag, index) in validateForm.value" :key="tag + '_tags'">
                        {{ mockingMobileTextTags(tag, index) }}
                      </span>
                    </div>
                    <div>
                      <img class="ml-auto" style="width: 32px; height: 32px" :src="getImgUrlPowerups('defaultCongrats')"
                        alt="imgEmptyFeed" />
                    </div>
                  </div>
                  <div class="card-footer"></div>
                  <div class="buttom"></div>
                </div>
              </div>
            </div>
          </div>
          <div class="grid-right">
            <div v-if="createRewardLoading" style="
                display: flex;
                flex: 1;
                justify-content: center;
                align-content: center;
              ">
              <loading-even></loading-even>
            </div>
            <div v-else>
              <el-form>
                <el-col :span="24">
                  <div>
                    <div v-if="autoMatePopup" :class="`flex-center autogen-warning ${autoMatePopupEdit ? 'active' : ''}`">
                      <img style="height: 22px" v-if="autoMatePopupEdit" :src="$utils('icons', 'ic_bolt_purple_24dp')"
                        alt="icons_ic_bolt_black_24dp" />
                      <img style="height: 22px" v-else :src="$utils('icons', 'ic_bolt_black_24dp')"
                        alt="icons_ic_bolt_black_24dp" />
                      <div v-if="autoMatePopupEdit" class="mt-2">
                        {{ $t("powerUp.This_power_up_automation_has_been") }}
                      </div>
                      <div v-else class="mt-2">
                        {{ $t("powerUp.This_power_up_automation_has") }}
                      </div>
                    </div>

                    <div v-if="validateForm.title !== ''">
                      <div class="fs-20 fw-700 fc-000000">
                        {{ validateForm.title }}
                      </div>
                      <div class="fs-14 pt-12 pb-16 fc-000000 wb-normal">
                        {{ validateForm.description }}
                      </div>


                      <div v-if="validateForm.typeRecognition == 'Medal'" class="grid-2-auto">
                        <div class="mr-8">
                          <div class="widthLabel">Medal Name</div>

                          <el-select size="mini" v-model="validateForm.labelMedal" placeholder="e.g., Rapid Responder" filterable clearable allow-create no-data-text="Create your first medal"
                            :filter-method="filterToFunctionLabel" @change="onChangelabel(validateForm.labelMedal)"
                            style="width: 100%;">
                            <el-option v-for="item in optionLabel" :key="item.value" :label="item.label"
                              :value="item.value">

                            </el-option>

                          </el-select>
                          <!-- <el-input
                          @input="onChangeAmountFunc_"
                          v-model="validateForm.labelMedal"
                          :min="0"
                          auto-complete="off"
                          placeholder="Label"
                        ></el-input> -->
                          
                        </div>
                        
                        <div class="ml-8">
                          <div class="widthLabel">{{ $t("powerUp.Medal_Design") }}</div>
                          <div style="position: relative;">


                            <el-select size="mini" v-model="validateForm.img" placeholder="Select" clearable
                              @change="onChangelabelMedal(validateForm.img)" style="width: 100%;">


                              <el-option class="custom-option" style="height: 119px;" v-for="item in optionsStatus"
                                :key="item.value" :label="'🏅 ' + item.label + ' Icon'" :value="item.value">
                                <template slot="default">
                                  <el-radio class="cssradio" v-model="validateForm.img" :label="item.value"
                                    style="display: flex; flex-direction: column;align-items: center;padding-top:16px;padding-bottom:12px;padding-left:0px;">
                                    <img :src="item.url" alt="Image" style="height: 75px;width: 53px; margin-left: -10px;">
                                  </el-radio>

                                </template>
                              </el-option>

                            </el-select>


                          </div>
                        </div>

                      </div>


                      <div v-else class="grid-2-auto">
                        <div class="mr-8">
                          <div class="widthLabel">{{ $t("powerUp.Reward_Type") }}</div>
                          <div id="typerecognition" style="position: relative;">
                            <el-input disabled :min="0" auto-complete="off"
                              :placeholder="validateForm.typeRecognition"></el-input>
                            <img v-if="validateForm.typeRecognition == 'Coin'" style="height: 32px; position: absolute;z-index: 1;
                          right: 12px; top: 7px;" :src="$utils('icons', 'icon_coin')" alt="icon_coin" />

                            <img v-if="validateForm.typeRecognition == 'Gem'" style="height: 32px; position: absolute;z-index: 1;
                          right: 12px; top: 7px;" :src="$utils('icons', 'icon_gem')" alt="icon_gem" />

                          </div>
                        </div>
                        <div class="ml-8">
                          <div class="widthLabel">{{ $t("powerUp.Amount") }}</div>
                          <el-input @input="onChangeAmountFunc_" type="number" v-model="validateForm.amount" :min="0"
                            auto-complete="off"
                            :placeholder="validateForm.typeRecognition == 'Gem' ? $t('powerUp.Number_of_gems') : $t('powerUp.Number_of_coins')"></el-input>
                        </div>

                      </div>


                    </div>
                    <div class="widthLabel flex-center">
                      {{ $t("powerUp.Recipient") }}
                      <div v-if="!validateForm.recipientsUser.length == 0 &&
                        !autoMatePopup
                        " class="mt-2 ml-auto">
                        <span class="txtRecipients" @click="openRecipientsDialog">{{
                          $utils(
                            "addCommasInNumber",
                            validateForm.recipientsUser.length
                          )
                        }}
                          {{ $t("powerUp.recipients") }}</span>
                      </div>
                    </div>
                    <div v-if="autoMatePopup" class="autogen-input recipients-style">
                      {{ $t("powerUp.Autogenerated") }}
                    </div>

                    <el-cascader v-else class="defaulttags input-recipient" ref="refTo" :disabled="!refreshInput"
                      v-model="validateForm.to" :placeholder="$t('powerUp.Name_of_Recipient_s')" :options="optionTo"
                      :props="propsCofig" :collapse-tags="validateForm.to.length > 18" @change="changeDataTo"
                      :filter-method="filterToFunction" :debounce="500" filterable :class="[ blurMode ?  'blurelement': '' ]">
                      <template slot-scope="{ node, data }">
                        <span v-if="data.toType == 'user'"
                        :class="[ blurMode ?  'blurelement': '' ]">{{ data.firstname }} {{ data.lastname }}</span>
                        <span v-else
                        :class="[ blurMode ?  'blurelement': '' ]">{{ data.label }}</span>
                      </template>
                    </el-cascader>
                  </div>

                  <div id="txtInputForStyle">
                    <div class="widthLabel flex-center">
                      {{ $t("powerUp.For") }}
                      <el-tooltip v-if="autoMatePopup" placement="top">
                        <div slot="content" class="cursor-pointe">
                          <span class="cursor-pointer" @click="
                            validateForm.for =
                            validateForm.for + '[[time_period]]'
                            ">
                            {{ $t("powerUp.Add") }} '{{ "[[time_period]]" }}' {{ $t("powerUp.for_showing_time_period") }}
                          </span>
                        </div>
                        <img @click="
                          validateForm.for =
                          validateForm.for + '[[time_period]]'
                          " class="ml-auto cursor-pointer" :src="$utils('icons', 'ic_help_gray_24px')"
                          alt="icons_ic_help_gray_24px" />
                      </el-tooltip>
                    </div>
                    <el-input v-model="validateForm.for" auto-complete="off"
                      :placeholder="$t('powerUp.Reason_for_recognition')"></el-input>
                  </div>

                  <div id="txtInputForStyle">
                    <div class="widthLabel">{{ $t("powerUp.Values_optional") }}</div>
                    <el-select class="selcet-value" v-model="validateForm.value" multiple filterable allow-create
                      default-first-option :placeholder="$t('powerUp.Select_values_optional')">
                      <el-option v-for="item in valuesOptional" :key="item.value" :label="item.label" :value="item.value">
                      </el-option>
                    </el-select>
                  </div>

                  <div class="default-placeholder-value">
                    <div v-if="!autoMatePopup" class="widthLabel">{{ $t("powerUp.Schedule") }}</div>
                    <div v-if="autoMatePopup" class="grid-2-50">
                      <div>
                        <div class="widthLabel">{{ $t("powerUp.Schedule") }}</div>
                        <div class="autogen-input schedule-style">
                          
                          {{ validateForm.path=='birthday'||validateForm.path=='workanniversary'? 'Same day':$t("powerUp.Following_work_day") }}
                        </div>
                      </div>
                      <div class="ml-16">
                        <div class="widthLabel">{{ $t("powerUp.Time") }}</div>
                        <el-time-select v-model="timePickerMock" :picker-options="{
                          start: '08:00',
                          step: '01:00',
                          end: '18:00',
                        }" :placeholder="$t('powerUp.Select_time')">
                        </el-time-select>
                      </div>
                    </div>
                    <el-date-picker v-else style="width: 100%" v-model="validateForm.when"
                      format="MMM dd, yyyy 'at' h:mmA" type="datetime" :placeholder="$t('powerUp.Now')"></el-date-picker>
                  </div>

                  <div v-if="validateForm.title == ''" class="grid-2-auto">
                    <div class="mr-8">
                      <div class="widthLabel">{{ $t("powerUp.Reward_Type") }}</div>
                      <el-cascader v-model="validateForm.type" separator=" > " style="width: 100%" ref="cascaderType"
                        :options="optionType" clearable :placeholder="$t('powerUp.Coin_Medal_or_Gem')"
                        @change="onChangeTypeFunc"></el-cascader>
                    </div>
                    <div class="ml-8">
                      <div class="widthLabel">{{ $t("powerUp.Amount") }}</div>
                      <el-input @input="onChangeAmountFunc" :disabled="validateForm.disAmount" type="number"
                        v-model="validateForm.amount" :min="0" auto-complete="off"
                        :placeholder="$t('powerUp.Number_of_coins')"></el-input>
                    </div>
                  </div>

                  <div class="relative flex-center mt-32">
                    <div class="switch-contrainer switch-contrainer-52">
                      <input type="checkbox" id="checkbox" class="input-checkbox" v-model="validateForm.share" />
                      <label for="checkbox" class="lable-checkbox">{{
                        validateForm.share
                      }}</label>
                    </div>
                    <div :class="`fs-16 ml-12 ${validateForm.share ? 'fc-6C30CC' : 'fc-000000 opa-05'
                        }`">
                      {{ $t("powerUp.Share_on_Activity_Feed") }}
                    </div>
                  </div>

                  <div class="mt-32">
                    <!-- <el-button type="send" style="width: 130px;" @click="sendPowerups">
                      <div
                        class="flex-mid"
                      >
                        <img
                          style="width: 18px; height: 21px"
                          :src="getImgUrl('ic_send-18px@2x')"
                        />
                        <span style="padding-left: 8px; padding-top: 2px"
                          >SEND</span
                        >
                      </div>
                    </el-button> -->
                    <!-- <el-button type="reset" @click="cancelAdd">RESET</el-button> -->
                    <div v-if="autoMatePopup && autoMatePopupEdit" class="flex-center">
                      <el-button class="btn-add bigger" @click.prevent="saveChanges">
                        <div class="flex-mid">
                          <span style="padding-left: 8px; padding-top: 2px">{{ $t("powerUp.SAVE_CHANGES") }}</span>
                        </div>
                      </el-button>
                      <el-button class="btn-cancel bigger" style="background-color: red" @click="deleteAutomation">
                        <div class="flex-mid" style="height: 21px">
                          <img :src="$utils('icons', 'ic_bolt_white_24dp')" alt="icons_ic_bolt_white_24dp" />
                          {{ $t("powerUp.DE_ACTIVATE_AUTOMATION") }}
                        </div>
                      </el-button>
                    </div>
                    <div v-else-if="autoMatePopup" class="flex-center">
                      <el-button class="btn-cancel bigger" @click="saveChanges">
                        <div class="flex-mid" style="height: 21px">
                          {{ $t("powerUp.SAVE_CHANGES") }}
                        </div>
                      </el-button>
                      <el-button class="btn-add bigger" @click.prevent="activateAutomation">
                        <div class="flex-mid">
                          <img :src="$utils('icons', 'ic_bolt_white_24dp')" alt="icons_ic_bolt_white_24dp" />
                          <span style="padding-left: 8px; padding-top: 2px">{{ $t("powerUp.ACTIVATE_AUTOMATION") }}</span>
                        </div>
                      </el-button>
                    </div>
                    <div v-else class="flex-center">
                      <el-button class="btn-add bigger" @click.prevent="sendPowerups">
                        <div class="flex-mid px-16">
                          <img style="width: 18px; height: 21px" :src="getImgUrl('ic_send-18px@2x')" />
                          <span style="padding-left: 8px; padding-top: 2px">{{ $t("powerUp.SEND") }}</span>
                        </div>
                      </el-button>
                      <el-button class="btn-cancel bigger" @click="cancelAdd">
                        <div class="flex-mid px-16" style="height: 21px">
                          {{ $t("powerUp.RESET") }}
                        </div>
                      </el-button>
                    </div>
                  </div>
                </el-col>
              </el-form>
            </div>
          </div>
        </div>
      </el-dialog>

      <el-dialog :visible.sync="dialogSendMedal"  width="500" top="30vh" center>
        <div class="fs-20" style="padding:30px 0px 0px 0px;text-align: center;">
          <span >
            This Medal has Already Been Delivered
        </span>
        </div>
        <div style="margin:0px 30px 0px 30px">
          <span >
          Someone on your team has already generated 🏅 {{reviewGem&&reviewGem.email_openai?reviewGem.email_openai.medal_name:''}} and delivered this medal to {{reviewGem?reviewGem.receive_firstname:''}}.
        </span>
        </div>
        
        <template #footer>
          <div class="dialog-footer">
            <el-button type="primary" @click="dialogSendMedal = false">
              Got it
            </el-button>
          </div>
        </template>
      </el-dialog>


    </div>
  </div>
</template>



<script>
import _ from "lodash";
import format from "date-fns/format";
import firebase from 'firebase/app';
export default {
  name: "outbox",
  components: {
    loadingEven: require("../even/loading").default,
  },

  mounted() {
    this.init();
  },
  data() {
    return {
      dialogFormVisible: false,
      validateForm: {
        to: [],
        for: "",
        when: "",
        type: [],
        amount: "",
        share: true,
        recipientsUser: [],
        txtName: "",
        txtReward: "",
        value: [],
        disAmount: true,
        title: '',
        description: '',
        typeRecognition: '',
        labelMedal: '',
        newLabel: false,
        img: '',
        urlImage: '',
        idmedal: '',
        th: '',
        en: ''
      },
      dialogCreateReward: false,
      MasterType: true,
      refreshInput: true,
      propsCofig: { multiple: true },
      autoMatePopup: false,
      autoMatePopupEdit: false,
      timePickerMock: "",
      timeMocking: "",
      dataAuto: {},
      optionsStatus: [
        { value: 'Charisma', label: 'Charisma', img: 'Charisma-on@3x', url: 'https://firebasestorage.googleapis.com/v0/b/people2-admin.appspot.com/o/images%2Fmedal%2FCharisma_on%402x.png?alt=media' },
        { value: 'Creativity', label: 'Creativity', img: 'Creativity-on@3x', url: 'https://firebasestorage.googleapis.com/v0/b/people2-admin.appspot.com/o/images%2Fmedal%2FCreativity_on%402x.png?alt=media&token=0ec4601b-d61b-462c-b753-0865cf970872' },
        { value: 'Initiative', label: 'Initiative', img: 'Initiative-on@3x', url: 'https://firebasestorage.googleapis.com/v0/b/people2-admin.appspot.com/o/images%2Fmedal%2FInitiative_on%402x.png?alt=media&token=86c0425f-5f8b-46e9-b590-399fb38cd770' },
        { value: 'Intelligence', label: 'Intelligence', img: 'Intelligence-on@3x', url: 'https://firebasestorage.googleapis.com/v0/b/people2-admin.appspot.com/o/images%2Fmedal%2FIntelligence_on%402x.png?alt=media&token=fc49d407-e1ec-4029-a3fc-150b1ff4180a' },
        { value: 'Kindness', label: 'Kindness', img: 'Kindness-on@3x', url: 'https://firebasestorage.googleapis.com/v0/b/people2-admin.appspot.com/o/images%2Fmedal%2FKindness_on%402x.png?alt=media&token=c30267c3-147e-4a66-8b46-3a4ee9d98572' },
        { value: 'Strength', label: 'Strength', img: 'Strength-on@3x', url: 'https://firebasestorage.googleapis.com/v0/b/people2-admin.appspot.com/o/images%2Fmedal%2FStrength_on%402x.png?alt=media&token=b1cf8608-990d-4291-8956-1bdcb8176813' }],
      radio1: '',
      optionLabel: [],
      reviewGemId:'',
      dialogSendMedal: false,

    };
  },
  created() {
    if(this.$router.currentRoute.params&&this.$router.currentRoute.params.id){
      this.reviewGemId=this.$router.currentRoute.params.id
      this.$store.dispatch("powerups/getReviewGem",this.$router.currentRoute.params.id);
      
    }
    if (!_.isEmpty(this.duplicateData)) {
      this.init();
    }
     this.$store.dispatch("powerups/getMenuListOfTimePeriods");
    this.$store.dispatch("powerups/getOrganization");
    this.$store.dispatch("powerups/getOptionType", this.user);
    this.$store.dispatch("powerups/getOptionTo", this.user);
    this.$store.dispatch("powerups/getHashtag", this.user);
    this.$store.commit("authen/setActiveIndex", "2");
  },
  computed: {
    user() {
      return this.$store.getters["authen/user"];
    },
    optionTo() {
      return this.$store.getters["powerups/optionTo"];
    },

    membersall() {
      return this.$store.getters["powerups/membersall"];
    },
    membersByTeam() {
      return this.$store.getters["powerups/membersByTeam"];
    },
    organizations() {
      return this.$store.getters["powerups/organizations"];
    },
    optionType() {
      return this.$store.getters["powerups/optionType"];
    },
    teamMaster() {
      return this.$store.getters["powerups/teamMaster"];
    },
    medalMaster() {
      return this.$store.getters["powerups/medalMaster"];
    },
    houseMaster() {
      return this.$store.getters["powerups/houseMaster"];
    },
    duplicateData() {
      return this.$store.getters["powerups/duplicateData"];
    },
    presentLibrary() {
      return this.$store.getters["powerups/presentLibrary"];
    },
    createRewardLoading() {
      const status = this.$store.getters["powerups/createRewardLoading"];
      if (!status) {
        this.changeDataTo(this.validateForm.to);
      }
      return status;
    },
    valuesOptional() {
      return this.$store.getters["powerups/valuesOptional"];
    },
    countAuto() {
      return this.$store.getters["powerups/countAuto"];
    },
    loadingPresetLibrary() {
      return this.$store.getters["powerups/loadingPresetLibrary"];
    },
    medal_Master() {
      return this.$store.getters["powerups/medal_Master"];
    },
    reviewGem() {
    
      return this.$store.getters["powerups/reviewGem"];
    },
    blurMode() {
      return this.$store.getters["demomode/blurMode"];
    },
  },
  mounted() {
    setTimeout(() => {
      //this.loadingPresetLibrary = false;
    }, 3000);
  },
  watch: {
    optionTo() {
      if (!this.MasterType) {
        this.validateForm.to = this.optionTo.map((row) => [row.value]);
      }
    },
    reviewGem(){
      // console.log('reviewGem',this.reviewGem)
      const image={
        "light-bulb":{url:'https://firebasestorage.googleapis.com/v0/b/people2-admin.appspot.com/o/images%2Fmedal%2FCreativity_on%402x.png?alt=media&token=0ec4601b-d61b-462c-b753-0865cf970872'},
        brain:{url:'https://firebasestorage.googleapis.com/v0/b/people2-admin.appspot.com/o/images%2Fmedal%2FIntelligence_on%402x.png?alt=media&token=fc49d407-e1ec-4029-a3fc-150b1ff4180a'}, 
        jester:{url:'https://firebasestorage.googleapis.com/v0/b/people2-admin.appspot.com/o/images%2Fmedal%2FCharisma_on%402x.png?alt=media'}, 
        fist:{url:'https://firebasestorage.googleapis.com/v0/b/people2-admin.appspot.com/o/images%2Fmedal%2FStrength_on%402x.png?alt=media&token=b1cf8608-990d-4291-8956-1bdcb8176813'}, 
        heart:{url:'https://firebasestorage.googleapis.com/v0/b/people2-admin.appspot.com/o/images%2Fmedal%2FKindness_on%402x.png?alt=media&token=c30267c3-147e-4a66-8b46-3a4ee9d98572'}, 
        gears:{url:'https://firebasestorage.googleapis.com/v0/b/people2-admin.appspot.com/o/images%2Fmedal%2FInitiative_on%402x.png?alt=media&token=86c0425f-5f8b-46e9-b590-399fb38cd770'}
      }

      if(this.reviewGem&&this.reviewGem.email_openai&&this.reviewGem.email_openai.send_powerups){

        this.dialogSendMedal = true;


      }else {
  
          const hashTag =this.reviewGem.email_openai.core_value.charAt(0)!=="#"?'#'+this.reviewGem.email_openai.core_value:this.reviewGem.email_openai.core_value
          const prefix = 'For';
          const removePrefix = this.reviewGem.email_openai.recognition.startsWith(prefix) ? this.reviewGem.email_openai.recognition.slice(prefix.length) : this.reviewGem.email_openai.recognition;
          
          
         this.setData({
         to:[{
          type : "user",
          email:this.reviewGem.receiver,
          name:''
         }],
        type:'medal',
        for:removePrefix,//this.reviewGem.email_openai.recognition,
        medals:{en:this.reviewGem.email_openai.medal_name,th:this.reviewGem.email_openai.medal_name,image:image[this.reviewGem.email_openai.design.toLowerCase()].url},
        medal:this.reviewGem.email_openai.medal_name,
        amount:10,
        value:hashTag,
        share:true,
      })
       
      
        this.dialogCreateReward = true;
   
      
      
     // this.dialogCreateReward = true;


        


      }

     
    }
  },
  methods: {
    init() {
      if (!_.isEmpty(this.duplicateData)) {
        this.setData(this.duplicateData);
        this.dialogCreateReward = true;
      }
    },
    getImgUrl(pic) {
      var images = require.context("../../assets/images/", false, /\.png$/);
      return images("./" + pic + ".png");
    },
    getImgUrlPowerups(pic) {
      var images = require.context(
        "../../assets/images/powerups/",
        false,
        /\.png$/
      );
      return images("./" + pic + ".png");
    },
    setOpacityShareCheck(share) {
      if (share) {
        return "opacity: 1;";
      } else {
        return "opacity: .8;";
      }
    },
    filterToFunction(node, keyword) {
      const keywordArr = keyword.split(/, | /);
      if (keywordArr.length > 1) {
        for (let i = 0; i < keywordArr.length; i++) {
          const keywordTrim = keywordArr[i].trim();
          if (node.data.toType == "user") {
            if (
              node.data.firstname
                .toLowerCase()
                .indexOf(keywordTrim.toLowerCase()) === 0
            ) {
              node.text = node.data.firstname + " " + node.data.lastname;
              return true;
            } else if (
              node.data.lastname
                .toLowerCase()
                .indexOf(keywordTrim.toLowerCase()) === 0
            ) {
              node.text = node.data.firstname + " " + node.data.lastname;
              return true;
            } else if (keywordTrim === node.data.email) {
              this.validateForm.to.push(["user_" + node.data.email]);
              this.refreshInput = false;
              setTimeout(() => {
                this.refreshInput = true;
              }, i * 75);
            }
          }
        }
        setTimeout(() => {
          this.$refs.refTo.inputValue = "";
          this.$refs.refTo.dropDownVisible = false;
        }, keywordArr.length * 75);
        this.$refs.refTo.handleClear();
      } else {
        if (node.data.toType == "user") {
          if (
            node.data.firstname.toLowerCase().indexOf(keyword.toLowerCase()) ===
            0
          ) {
            node.text = node.data.firstname + " " + node.data.lastname;
            return true;
          } else if (
            node.data.lastname.toLowerCase().indexOf(keyword.toLowerCase()) ===
            0
          ) {
            node.text = node.data.firstname + " " + node.data.lastname;
            return true;
          } else if (keyword === node.data.email) {
            this.validateForm.to.push(["user_" + node.data.email]);
            this.refreshInput = false;
            this.changeDataTo(this.validateForm.to);
            setTimeout(() => {
              this.refreshInput = true;
            }, 100);
            this.$refs.refTo.inputValue = "";
            this.$refs.refTo.dropDownVisible = false;
            this.$refs.refTo.handleClear();
          }
        } else {
          return (
            node
              .getText(false, null)
              .toLowerCase()
              .indexOf(keyword.toLowerCase()) >= 0
          );
        }
      }
    },
    filterToFunctionLabel(node, keyword) {
      // console.log('keyword',keyword)
      // console.log('node',node)
      const _find = _.find(this.medal_Master[this.validateForm.img], { value: node })
     
      if (_find) {

        this.validateForm.txtReward =
          "🏅" + this.validateForm.labelMedal + " (+10)";

        this.validateForm.idmedal = _find ? _find.key : ''
        this.validateForm.en = _find ? _find.en : ''
        this.validateForm.th = _find ? _find.th : ''
        this.validateForm.type = ["medal", node]
        this.validateForm.newLabel = false
      } else {
        this.validateForm.labelMedal = node
        this.validateForm.type = ["medal", node]
        this.validateForm.txtReward =
          "🏅" + this.validateForm.labelMedal + " (+10)";
        this.validateForm.newLabel = true

      }

    },
    onChangeTypeFunc() {

      if (this.validateForm.type[0] == "medal") {
        this.validateForm.amount = 1;
        this.validateForm.disAmount = true;
        this.validateForm.txtReward =
          "🏅" + this.medalMaster[this.validateForm.type[1]] + " (+10)";
      } else if (this.validateForm.type[0] == "coin") {
        if (this.validateForm.type[1] == "3_coins") {
          this.validateForm.amount = 3;
          this.validateForm.txtReward = "";
          this.validateForm.disAmount = true;
        } else if (this.validateForm.type[1] == "5_coins") {
          this.validateForm.amount = 5;
          this.validateForm.txtReward = "";
          this.validateForm.disAmount = true;
        } else {
          this.validateForm.amount = "";
          this.validateForm.txtReward = "";
          this.validateForm.disAmount = false;
        }
        this.validateForm.txtReward = "+" + this.validateForm.amount;
        if (parseInt(this.validateForm.amount) > 1) {
          this.validateForm.txtReward += " coins";
        } else {
          this.validateForm.txtReward += " coin";
        }
      } else if (this.validateForm.type[0] == "gem") {
        if (this.validateForm.type[1] == "1_gem") {
          this.validateForm.amount = 1;
          this.validateForm.txtReward = "";
          this.validateForm.disAmount = true;
        } else {
          this.validateForm.amount = "";
          this.validateForm.txtReward = "";
          this.validateForm.disAmount = false;
        }
        this.validateForm.txtReward = "+" + this.validateForm.amount;
        if (parseInt(this.validateForm.amount) > 1) {
          this.validateForm.txtReward += " gems";
        } else {
          this.validateForm.txtReward += " gem";
        }
      } else {
        this.validateForm.amount = "";
        this.validateForm.disAmount = false;
        this.validateForm.txtReward = "";
      }
    },
    onChangeAmountFunc() {
  
      if (this.validateForm.type[0] == "coin") {
        this.validateForm.txtReward = "+" + this.validateForm.amount;
        if (parseInt(this.validateForm.amount) > 1) {
          this.validateForm.txtReward += " coins";
        } else {
          this.validateForm.txtReward += " coin";
        }
      } else if (this.validateForm.type[0] == "gem") {
        this.validateForm.txtReward = "+" + this.validateForm.amount;
        if (parseInt(this.validateForm.amount) > 1) {
          this.validateForm.txtReward += " gems";
        } else {
          this.validateForm.txtReward += " gem";
        }
      } else if (this.validateForm.type[0] == "medal") {
        if(!this.medalMaster[this.validateForm.type[1]]){
          this.validateForm.txtReward ="🏅" + this.validateForm.type[1] + " (+10)";
  
          this.validateForm.newLabel = true
        }else{
          this.validateForm.txtReward =
          "🏅" + this.medalMaster[this.validateForm.type[1]] + " (+10)";
          this.validateForm.newLabel = false
        }
      }
     
    },
    onChangeAmountFunc_() {
      if (this.validateForm.typeRecognition == 'Coin') {
        this.validateForm.txtReward = "+" + this.validateForm.amount;
        if (parseInt(this.validateForm.amount) > 1) {
          this.validateForm.txtReward += " coins";
        } else {
          this.validateForm.txtReward += " coin";
        }
        this.validateForm.type = ['coin']
      } else if (this.validateForm.typeRecognition == 'Gem') {
        this.validateForm.txtReward = "+" + this.validateForm.amount;
        if (parseInt(this.validateForm.amount) > 1) {
          this.validateForm.txtReward += " gems";
        } else {
          this.validateForm.txtReward += " gem";
        }
        this.validateForm.type = ['gem']
      } else if (this.validateForm.typeRecognition == 'Medal') {
        this.validateForm.txtReward =
          "🏅" + this.validateForm.labelMedal + " (+10)";
        this.validateForm.type = ['medal']

      }
    },
    onChangelabelMedal(value) {

      const _find = _.find(this.optionsStatus, { value: value })
      this.validateForm.urlImage = _find.url
      this.optionLabel = this.medal_Master[value]
      const _findLabel = _.find(this.medal_Master[value], { value: this.validateForm.labelMedal})
  
      if(!_findLabel){

        this.validateForm.newLabel = true
      }
    },
    onChangelabel(value) {
      this.validateForm.txtReward =
        "🏅" + this.validateForm.labelMedal + " (+10)";
      const _find = _.find(this.optionLabel, { value: value })
      this.validateForm.idmedal = _find ? _find.key : ''
      this.validateForm.en = _find ? _find.en : ''
      this.validateForm.th = _find ? _find.th : ''
      this.validateForm.type = ["medal", value]
      this.validateForm.img= _find.medalImage
      this.validateForm.newLabel = false
    },
    openRecipientsDialog() {
      this.dialogFormVisible = true;
    },
    cancelDialog() { this.dialogFormVisible = false;},
    getTeamOfParent(parent, teams) {
      for (const i in parent) {
        teams[parent[i]["team_id"]] = true;
        if (parent[i]["parent"]) {
          teams = this.getTeamOfParent(parent[i]["parent"], teams);
        }
      }
      return teams;
    },
    removeDataTo(tagRemove) {
      if (tagRemove[0].indexOf("user_") !== -1) {
        for (const i in this.$refs["refTo"].getCheckedNodes()) {
          if (this.$refs["refTo"].getCheckedNodes()[i].value == tagRemove[0]) {
            this.$refs["refTo"].getCheckedNodes()[i].pathLabels[0] =
              this.$refs["refTo"].getCheckedNodes()[i].data.firstname +
              " " +
              this.$refs["refTo"].getCheckedNodes()[i].data.lastname;
          }
        }
      }
    },
    changeDataTo(arrTag) {
      let _data = [];
      let teamIn = [];
      let chk_person = 0;
      let chk_team = 0;
      let chk_house = 0;
      let chk_all = false;
      let txtName = "";
      const organizations = this.organizations;
      for (const i in arrTag) {
        if (arrTag[i][0] == "all_members") {
          _data = this.membersall;
          chk_all = true;
          break;
        } else if (arrTag[i][0].indexOf("team_") !== -1) {
          chk_team++;
          let teamId = arrTag[i][0].replace(/team_/g, "");
          let arrTeam = organizations[teamId];
          if (arrTeam) {
            if (arrTeam.parent) {
              if (teamIn[teamId] === undefined) {
                teamIn[teamId] = new Array();
              }
              teamIn[teamId][teamId] = true;
              teamIn[teamId] = this.getTeamOfParent(
                arrTeam.parent,
                teamIn[teamId]
              );
              for (const k in teamIn[teamId]) {
                const userTeam = _.filter(this.membersall, { team: k });
                if (userTeam.length > 0) {
                  for (const x in userTeam) {
                    let chkUser = _.filter(_data, { email: userTeam[x].email });
                    if (chkUser.length == 0) {
                      _data.push(userTeam[x]);
                    }
                  }
                }
              }
            }
          } else {
            const userTeam = _.filter(this.membersall, { team: teamId });
            if (userTeam.length > 0) {
              for (const j in userTeam) {
                let chkUser = _.filter(_data, { email: userTeam[j].email });
                if (chkUser.length == 0) {
                  _data.push(userTeam[j]);
                }
              }
            }
          }
        } else if (arrTag[i][0].indexOf("user_") !== -1) {
          chk_person++;
          let userId = arrTag[i][0].replace(/user_/g, "");
          const userTeam = _.filter(this.membersall, { email: userId });
          if (userTeam.length > 0) {
            let chkUser = _.filter(_data, { email: userTeam[0].email });
            if (chkUser.length == 0) {
              _data.push(userTeam[0]);
            }
          }
        } else if (arrTag[i][0].indexOf("house_") !== -1) {
          chk_house++;
          let houseId = arrTag[i][0].replace(/house_/g, "");
          const userHouse = _.filter(this.membersall, { house: houseId });
          if (userHouse.length > 0) {
            for (const j in userHouse) {
              let chkUser = _.filter(_data, { email: userHouse[j].email });
              if (chkUser.length == 0) {
                _data.push(userHouse[j]);
              }
            }
          }
        }
      }
      const result = _.sortBy(_data, [
        function (o) {
          return o.firstname;
        },
      ]);
      if (chk_all) {
        txtName = "Everyone";
      } else if (
        chk_person ||
        (chk_team > 0 && chk_person > 0) ||
        (chk_team > 0 && chk_house > 0) ||
        (chk_person > 0 && chk_house > 0)
      ) {
        let _count = 1;
        for (const i in result) {
          if (result.length > 2) {
            if (_count > 2) {
              txtName += ", and " + (result.length - 2) + " others";
              break;
            } else {
              if (txtName) {
                txtName +=
                  ", " +
                  result[i].firstname +
                  " " +
                  result[i].lastname.charAt(0);
              } else {
                txtName =
                  result[i].firstname + " " + result[i].lastname.charAt(0);
              }
            }
          } else {
            if (txtName) {
              txtName +=
                " and " +
                result[i].firstname +
                " " +
                result[i].lastname.charAt(0);
            } else {
              txtName =
                result[i].firstname + " " + result[i].lastname.charAt(0);
            }
          }
          _count++;
        }
      } else if (chk_team > 0 && !chk_person && !chk_house) {
        let _count = 1;
        for (const i in arrTag) {
          if (arrTag.length > 2) {
            if (_count > 2) {
              txtName += ", and " + (arrTag.length - 2) + " others";
              break;
            } else {
              let teamId = arrTag[i][0].replace(/team_/g, "");
              if (txtName) {
                txtName += ", " + this.teamMaster[teamId].name;
              } else {
                txtName = this.teamMaster[teamId].name;
              }
            }
          } else {
            let teamId = arrTag[i][0].replace(/team_/g, "");
            if (txtName) {
              txtName += " and " + this.teamMaster[teamId].name;
            } else {
              txtName = this.teamMaster[teamId].name;
            }
          }
          _count++;
        }
      } else if (chk_house > 0 && !chk_team && !chk_person) {
        let _count = 1;
        for (const i in arrTag) {
          if (arrTag.length > 2) {
            if (_count > 2) {
              txtName += ", and " + (arrTag.length - 2) + " others";
              break;
            } else {
              let houseId = arrTag[i][0].replace(/house_/g, "");
              if (txtName) {
                txtName += ", " + this.houseMaster[houseId];
              } else {
                txtName = this.houseMaster[houseId];
              }
            }
          } else {
            let houseId = arrTag[i][0].replace(/house_/g, "");
            if (txtName) {
              txtName += " and " + this.houseMaster[houseId];
            } else {
              txtName = this.houseMaster[houseId];
            }
          }
          _count++;
        }
      }
      this.validateForm.txtName = txtName;
      this.validateForm.recipientsUser = result;

    },
    changeArrDataTo(arrTag) {
      let _data = [];
      let teamIn = [];
      let chk_person = 0;
      let chk_team = 0;
      let chk_house = 0;
      let chk_all = false;
      let txtName = "";
      const organizations = this.organizations;
      for (const i in arrTag) {
        if (arrTag[i] == "all_members") {
          _data = this.membersall;
          chk_all = true;
          break;
        } else if (arrTag[i].indexOf("team_") !== -1) {
          chk_team++;
          let teamId = arrTag[i].replace(/team_/g, "");
          let arrTeam = organizations[teamId];
          if (arrTeam) {
            if (arrTeam.parent) {
              if (teamIn[teamId] === undefined) {
                teamIn[teamId] = new Array();
              }
              teamIn[teamId][teamId] = true;
              teamIn[teamId] = this.getTeamOfParent(
                arrTeam.parent,
                teamIn[teamId]
              );
              for (const k in teamIn[teamId]) {
                const userTeam = _.filter(this.membersall, { team: k });
                if (userTeam.length > 0) {
                  for (const x in userTeam) {
                    let chkUser = _.filter(_data, { email: userTeam[x].email });
                    if (chkUser.length == 0) {
                      _data.push(userTeam[x]);
                    }
                  }
                }
              }
            }
          } else {
            const userTeam = _.filter(this.membersall, { team: teamId });
            if (userTeam.length > 0) {
              for (const j in userTeam) {
                let chkUser = _.filter(_data, { email: userTeam[j].email });
                if (chkUser.length == 0) {
                  _data.push(userTeam[j]);
                }
              }
            }
          }
        } else if (arrTag[i].indexOf("user_") !== -1) {
          chk_person++;
          let userId = arrTag[i].replace(/user_/g, "");
          const userTeam = _.filter(this.membersall, { email: userId });
          if (userTeam.length > 0) {
            let chkUser = _.filter(_data, { email: userTeam[0].email });
            if (chkUser.length == 0) {
              _data.push(userTeam[0]);
            }
          }
        } else if (arrTag[i].indexOf("house_") !== -1) {
          chk_house++;
          let houseId = arrTag[i].replace(/house_/g, "");
          const userHouse = _.filter(this.membersall, { house: houseId });
          if (userHouse.length > 0) {
            for (const j in userHouse) {
              let chkUser = _.filter(_data, { email: userHouse[j].email });
              if (chkUser.length == 0) {
                _data.push(userHouse[j]);
              }
            }
          }
        }
      }
      const result = _.sortBy(_data, [
        function (o) {
          return o.firstname;
        },
      ]);
      if (chk_all) {
        txtName = "Everyone";
      } else if (
        chk_person ||
        (chk_team > 0 && chk_person > 0) ||
        (chk_team > 0 && chk_house > 0) ||
        (chk_person > 0 && chk_house > 0)
      ) {
        let _count = 1;
        for (const i in result) {
          if (result.length > 2) {
            if (_count > 2) {
              txtName += ", and " + (result.length - 2) + " others";
              break;
            } else {
              if (txtName) {
                txtName +=
                  ", " +
                  result[i].firstname +
                  " " +
                  result[i].lastname.charAt(0);
              } else {
                txtName =
                  result[i].firstname + " " + result[i].lastname.charAt(0);
              }
            }
          } else {
            if (txtName) {
              txtName +=
                " and " +
                result[i].firstname +
                " " +
                result[i].lastname.charAt(0);
            } else {
              txtName =
                result[i].firstname + " " + result[i].lastname.charAt(0);
            }
          }
          _count++;
        }
      } else if (chk_team > 0 && !chk_person && !chk_house) {
        let _count = 1;
        for (const i in arrTag) {
          if (arrTag.length > 2) {
            if (_count > 2) {
              txtName += ", and " + (arrTag.length - 2) + " others";
              break;
            } else {
              let teamId = arrTag[i].replace(/team_/g, "");
              if (txtName) {
                txtName += ", " + this.teamMaster[teamId].name;
              } else {
                txtName = this.teamMaster[teamId].name;
              }
            }
          } else {
            let teamId = arrTag[i].replace(/team_/g, "");
            if (txtName) {
              txtName += " and " + this.teamMaster[teamId].name;
            } else {
              txtName = this.teamMaster[teamId].name;
            }
          }
          _count++;
        }
      } else if (chk_house > 0 && !chk_team && !chk_person) {
        let _count = 1;
        for (const i in arrTag) {
          if (arrTag.length > 2) {
            if (_count > 2) {
              txtName += ", and " + (arrTag.length - 2) + " others";
              break;
            } else {
              let houseId = arrTag[i].replace(/house_/g, "");
              if (txtName) {
                txtName += ", " + this.houseMaster[houseId];
              } else {
                txtName = this.houseMaster[houseId];
              }
            }
          } else {
            let houseId = arrTag[i].replace(/house_/g, "");
            if (txtName) {
              txtName += " and " + this.houseMaster[houseId];
            } else {
              txtName = this.houseMaster[houseId];
            }
          }
          _count++;
        }
      }
      this.validateForm.txtName = txtName;
      this.validateForm.recipientsUser = result;
    },
    removeUserClick(item) {
      this.$confirm(
        `Are you sure you want to remove <strong>${item.firstname} ${item.lastname}</strong> from the recipient list?`,
        "Warning",
        {
          dangerouslyUseHTMLString: true,
          confirmButtonText: "Yes",
          cancelButtonText: "Cancel",
          type: "warning",
        }
      )
        .then(() => {
          const organizations = this.organizations;
          let tag = this.validateForm.to;
          let tagSplitAll = [];
          let teamIn = [];
          const index = this.validateForm.recipientsUser.findIndex(
            (obj) => obj.email === item.email
          );
          this.validateForm.recipientsUser.splice(index, 1);
          for (const i in this.validateForm.to) {
            if (this.validateForm.to[i][0] == "all_members") {
              for (const j in this.membersall) {
                if (this.membersall[j].email !== item.email) {
                  let chkUser = _.indexOf(
                    tagSplitAll,
                    "user_" + this.membersall[j].email
                  );
                  if (chkUser == -1) {
                    tagSplitAll.push("user_" + this.membersall[j].email);
                  }
                }
              }
            } else if (this.validateForm.to[i][0].indexOf("team_") !== -1) {
              let teamId = this.validateForm.to[i][0].replace(/team_/g, "");
              let arrTeam = organizations[teamId];
              let tapSplitTeam = [];
              let chk_userTeam = false;
              if (arrTeam) {
                if (arrTeam.parent) {
                  if (teamIn[teamId] === undefined) {
                    teamIn[teamId] = new Array();
                  }
                  teamIn[teamId][teamId] = true;
                  teamIn[teamId] = this.getTeamOfParent(
                    arrTeam.parent,
                    teamIn[teamId]
                  );
                  for (const k in teamIn[teamId]) {
                    const userTeam = _.filter(this.membersall, { team: k });
                    if (userTeam.length > 0) {
                      for (const x in userTeam) {
                        if (userTeam[x].email == item.email) {
                          chk_userTeam = true;
                        } else {
                          let chk_userDup = _.indexOf(
                            tagSplitAll,
                            "user_" + userTeam[x].email
                          );
                          if (chk_userDup == -1) {
                            tapSplitTeam.push("user_" + userTeam[x].email);
                          }
                        }
                      }
                    }
                  }
                }
              } else {
                const userTeam = _.filter(this.membersall, { team: teamId });
                if (userTeam.length > 0) {
                  for (const j in userTeam) {
                    if (userTeam[j].email == item.email) {
                      chk_userTeam = true;
                    } else {
                      let chk_userDup = _.indexOf(
                        tagSplitAll,
                        "user_" + userTeam[j].email
                      );
                      if (chk_userDup == -1) {
                        tapSplitTeam.push("user_" + userTeam[j].email);
                      }
                    }
                  }
                }
              }
              if (chk_userTeam) {
                tagSplitAll = tagSplitAll.concat(tapSplitTeam);
              } else {
                tagSplitAll.push(this.validateForm.to[i][0]);
              }
            } else if (this.validateForm.to[i][0].indexOf("user_") !== -1) {
              let userId = this.validateForm.to[i][0].replace(/user_/g, "");
              if (userId !== item.email) {
                let chk_userDup = _.indexOf(tagSplitAll, "user_" + userId);
                if (chk_userDup == -1) {
                  tagSplitAll.push("user_" + userId);
                }
              }
            }
          }

          let result = [];
          for (const i in tagSplitAll) {
            result.push([tagSplitAll[i]]);
          }
          this.validateForm.to = result;
          this.changeDataTo(result);
          this.$message({
            type: "success",
            message: "User removed from recipient list",
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "Canceled",
          });
        });
    },
    sendPowerups() {

      if (
        this.validateForm.to.length == 0 ||
        !this.validateForm.for.replace(/ /g, "") ||
        this.validateForm.type.length == 0 ||
        !this.validateForm.amount ||
        this.validateForm.amount <= 0
      ) {
        this.$message({
          showClose: true,
          message: "Valid Data required.",
          type: "error",
        });
        return false;
      } else {
        this.$confirm(
          "Are you sure you want to send recognition to the selected recipient(s)?",
          "Warning",
          {
            confirmButtonText: "Confirm",
            cancelButtonText: "Cancel",
            type: "warning",
            center: true,
          }
        )
          .then(() => {
            // console.log('this.validateForm',this.validateForm)
           
            if(this.reviewGemId!=''){
              //console.log('this.reviewGemId',this.reviewGemId)
              this.$store.dispatch("powerups/updateReviewGemSendPowerups", this.reviewGemId);
            }
            //console.log('this.validateForm',this.validateForm)
              this.$store.dispatch("powerups/sendPowerups", this.validateForm);
          })
          .then(() => {
            this.dialogCreateReward = false;
            // this.cancelAdd();
            this.$message({
              type: "success",
              message:
                "Power-up engaged! Recognition sent successfully. Please wait up to a minute...",
            });
          })
          .catch(() => {
            this.$message({
              type: "info",
              message: "Canceled",
            });
          });
      }
    },
    cancelAdd() {
      this.validateForm.to = [];
      this.validateForm.for = "";
      this.validateForm.when = "";
      this.validateForm.type = [];
      this.validateForm.amount = "";
      this.validateForm.share = true;
      this.validateForm.recipientsUser = [];
      this.validateForm.txtName = "";
      this.validateForm.txtReward = "";
      this.validateForm.disAmount = true;
      this.validateForm.value = [];
      this.validateForm.title = ''
      this.validateForm.description = ''
      this.typeRecognition = ''
      this.validateForm.labelMedal = ''
      this.validateForm.newLabel = false
      this.validateForm.img = ''
      this.validateForm.urlImage = ''
      this.validateForm.idmedal = ''
      this.validateForm.th = ''
      this.validateForm.en = ''

      this.timeMocking = "";
      this.$store.commit("powerups/setObjDuplicate", {});
      this.MasterType = true;
    },
    setData(item) {
     
      let tags = _.find(this.valuesOptional, { label: item.value });

      let arrTag = [];
      let arrType = [];
      //this.validateForm.value=[item.value]
      if (item.to) {
        for (const i in item.to) {
          if (item.to[i].type == "all") {
            arrTag.push(["all_members"]);
          } else if (item.to[i].type == "user") {
            arrTag.push(["user_" + item.to[i].email]);
          } else if (item.to[i].type == "team") {
            arrTag.push(["team_" + item.to[i].id]);
          } else if (item.to[i].type == "house") {
            arrTag.push(["house_" + item.to[i].id]);
          }
        }
      }
      arrType.push(item.type);
      if (item.type == "medal") {
        arrType.push(item.medal);
        this.validateForm.disAmount = true;
      } else if (item.type == "coin") {
        if (item.amount == 3) {
          this.validateForm.disAmount = true;
          arrType.push("3_coins");
        } else if (item.amount == 5) {
          this.validateForm.disAmount = true;
          arrType.push("5_coins");
        } else {
          this.validateForm.disAmount = false;
          arrType.push("coin_amount");
        }
      } else if (item.type == "gem") {
        if (item.amount == 1) {
          this.validateForm.disAmount = true;
          arrType.push("1_gem");
        } else {
          this.validateForm.disAmount = false;
          arrType.push("gem_amount");
        }
      } else {
        this.validateForm.disAmount = false;
      }
      this.validateForm.to = arrTag;
      this.validateForm.for = item.for;
      this.validateForm.when = "";
      this.validateForm.type = arrType;
      this.validateForm.amount = item.amount;
      this.validateForm.share = item.share;
      this.validateForm.value = [tags.value]//[item.value];
      // this.validateForm.title = item.title;
      // this.validateForm.description = item.description;
      if (item.type == 'coin') {
        this.validateForm.title = 'Send Coin Recognition'
        this.validateForm.description = 'Perfect for reinforcing your values and rewarding those who are exhibiting behaviors you want to encourage.'
        this.validateForm.typeRecognition = 'Coin'
      } else if (item.type == 'gem') {
        this.validateForm.title = 'Send Gem Recognition'
        this.validateForm.description = 'Ideal for recognizing performance achieved on goals, supporting others, and consistently acting according to core values.'
        this.validateForm.typeRecognition = 'Gem'
      } else if (item.type == 'medal') {
        this.validateForm.title = 'Send Medal Recognition'
        this.validateForm.description = 'Best for recognizing exceptional achievements and accolades that becomes a fixture on the individual’s profile'
        this.validateForm.typeRecognition = 'Medal'
        this.validateForm.amount = 10
        this.validateForm.labelMedal = item.medals.en
        this.validateForm.idmedal = item.medal
        this.validateForm.th = item.medals.th
  
        //this.validateForm.value= ['thisWillBePreSelected','ssss']
        if (item.medals) {
          const _find = _.find(this.optionsStatus, { url: item.medals.image })
  
          this.validateForm.img = _find ? _find.value : ''
          this.validateForm.urlImage = _find ? _find.url : ''
        } else {
          this.validateForm.img = ''
          this.validateForm.urlImage = ''
        }

      } else {
        this.validateForm.title = ''
        this.validateForm.description = ''
      }


      this.onChangeAmountFunc();
      this.changeDataTo(arrTag);
      this.$store.commit("powerups/setObjDuplicate", {});
    },
    handleClickDropdown(data) {
       //console.log("dddd",data)
      if (data.status_disable == "disable_false") {
        this.autoMatePopup = true;
        this.autoMatePopupEdit = false;
      } else if (data.status_disable == "disable_true") {
        this.autoMatePopup = true;
        this.autoMatePopupEdit = true;
      } else {
        this.autoMatePopup = false;
        this.autoMatePopupEdit = false;
      }

      this.cancelAdd();
      this.validateForm.recipientsUser = [];
      this.MasterType = false;
      this.validateForm.value = [];

      let current = "";

      if (data == 'Give Coins') {
        this.validateForm.title = 'Send Coin Recognition'
        this.validateForm.description = 'Perfect for reinforcing your values and rewarding those who are exhibiting behaviors you want to encourage.'
        this.validateForm.typeRecognition = 'Coin'
      } else if (data == 'Give a Gem') {
        this.validateForm.title = 'Send Gem Recognition'
        this.validateForm.description = 'Ideal for recognizing performance achieved on goals, supporting others, and consistently acting according to core values.'
        this.validateForm.typeRecognition = 'Gem'
      } else if (data == 'Give a Medal') {
        this.validateForm.title = 'Send Medal Recognition'
        this.validateForm.description = 'Best for recognizing exceptional achievements and accolades that becomes a fixture on the individual’s profile'
        this.validateForm.typeRecognition = 'Medal'
        for(let i in this.medal_Master){
          this.optionLabel.push(...this.medal_Master[i])
        }
        this.validateForm.amount = 10
      } else {
        this.validateForm.title = ''
        this.validateForm.description = ''
      }

      if (data.typeList == "month") {
        current = format(new Date(), 'MMMM YYYY')
      } else if (data.typeList == "quarter") {
        current = "Q" + format(new Date(), 'Q YYYY')
      } else {
        current = format(new Date(), 'YYYY')
      }
      let time_period = "";
      if (this.autoMatePopup && !this.autoMatePopupEdit) {
        time_period = "[[time_period]]";
        this.timeMocking = current;

      } else if (this.autoMatePopup && this.autoMatePopupEdit) {
        time_period = "";
        this.timeMocking = current;

      } else {
        time_period = data.menuList;
      }
      if (data.status_disable && data.auto) {
        //console.log('autooooo')
        let type = []
        if (data.auto.type == "coin") {
          if (data.auto.amount == 3) {
            type = ["coin", "3_coins"];
          } else if (data.auto.amount == 5) {
            type = ["coin", "3_coins"];
          } else {
            type = ["coin", "coin_amount"];
          }

        } else if (data.auto.type == "gem") {
          if (data.auto.amount == 1) {
            type = ["gem", "1_gem"];
          } else {

            type = ["gem", "gem_amount"];
          }

        } else {
          type = ['medal', data.auto.medal]

        }
        let hashTag = []
        data.auto.hashtag.map(data => {
          let valuesOptional = _.find(this.valuesOptional, { label: data });
          if (valuesOptional !== undefined) {
            hashTag.push(valuesOptional.value)
          }
        })

        this.validateForm.amount = data.auto.amount;
        this.validateForm.share = data.auto.share;
        this.validateForm.for = data.auto.for;
        this.validateForm.txtReward = data.auto.type;
        this.validateForm.type = type
        this.validateForm.sendType = data.typeList
        this.validateForm.value = hashTag
        this.validateForm.path = data.path
        this.dataAuto = data.auto
        this.dataAuto.path = data.path

        this.timePickerMock = data.auto.time


      } else {
        if (data.type == "Perfect Attendance") {
          if (!data.status_disable) {
            this.$store.dispatch("powerups/getDataTo", {
              data: data,
              user: this.user,
            });
          }
          this.validateForm.amount = 1;
          this.validateForm.share = true;
          this.validateForm.for = `perfect attendance for ${time_period}`;
          this.validateForm.txtReward = " coin";
          this.validateForm.type = ["coin", "coin_amount"];
          this.validateForm.disAmount = false;
          this.validateForm.when = new Date();
        } else if (data.type == "New Members") {
          if (!data.status_disable) {
            this.$store.dispatch("powerups/getDataTo", {
              data: data,
              user: this.user,
            });
          }
          this.validateForm.amount = 5;
          this.validateForm.share = true;
          this.validateForm.for = `joining our workplace community in ${time_period}`;
          this.validateForm.txtReward = " coin";
          this.validateForm.type = ["coin", "5_coins"];
          this.validateForm.disAmount = true;
          this.validateForm.when = new Date();
        } else if (data.type == "Leading a Class") {
          if (!data.status_disable) {
            this.$store.dispatch("powerups/getDataTo", {
              data: data,
              user: this.user,
            });
          }
          this.validateForm.amount = 50;
          this.validateForm.share = true;
          this.validateForm.for = `taking the time and effort to lead a University session in ${time_period}`;
          this.validateForm.txtReward = " coin";
          this.validateForm.type = ["coin", "coin_amount"];
          this.validateForm.disAmount = false;
          this.validateForm.when = new Date();
        } else if (data.type == "House MVPs") {
          if (!data.status_disable) {
            this.$store.dispatch("powerups/getDataTo", {
              data: data,
              user: this.user,
            });
          }
          this.validateForm.amount = 50;
          this.validateForm.share = true;
          this.validateForm.for = `earning the most XP for your Happily House in ${time_period}`;
          this.validateForm.txtReward = " coin";
          this.validateForm.type = ["coin", "coin_amount"];
          this.validateForm.disAmount = false;
          this.validateForm.when = new Date();
        } else if (data.type == "Super Feedback") {
          if (!data.status_disable) {
            this.$store.dispatch("powerups/getDataTo", {
              data: data,
              user: this.user,
            });
          }
          this.validateForm.amount = 3;
          this.validateForm.share = false;
          this.validateForm.for = `taking the effort to share super feedback. You're in the top 5 for ${time_period}`;
          this.validateForm.txtReward = " coin";
          this.validateForm.type = ["coin", "3_coins"];
          this.validateForm.disAmount = true;
          this.validateForm.when = new Date();
        } else if (data.type == "Super Recognition") {
          if (!data.status_disable) {
            this.$store.dispatch("powerups/getDataTo", {
              data: data,
              user: this.user,
            });
          }
          this.validateForm.amount = 3;
          this.validateForm.share = false;
          this.validateForm.for = `taking the extra effort provide quality recognition to your peers in ${time_period}`;
          this.validateForm.txtReward = " coin";
          this.validateForm.type = ["coin", "3_coins"];
          this.validateForm.disAmount = true;
          this.validateForm.when = new Date();
        } else if (data.type == "Leading Discussions") {
          if (!data.status_disable) {
            this.$store.dispatch("powerups/getDataTo", {
              data: data,
              user: this.user,
            });
          }
          this.validateForm.amount = 5;
          this.validateForm.share = false;
          this.validateForm.for = `creating a Town Hall discussion ${time_period}`;
          this.validateForm.txtReward = " coin";
          this.validateForm.type = ["coin", "5_coins"];
          this.validateForm.disAmount = true;
          this.validateForm.when = new Date();
        } else if (data.type == "Active Managers") {
          if (!data.status_disable) {
            this.$store.dispatch("powerups/getDataTo", {
              data: data,
              user: this.user,
            });
          }
          this.validateForm.amount = 50;
          this.validateForm.share = false;
          this.validateForm.for = `taking care of your team by being an active manager in ${time_period}`;
          this.validateForm.txtReward = " coin";
          this.validateForm.type = ["coin", "coin_amount"];
          this.validateForm.disAmount = false;
          this.validateForm.when = new Date();
        } else if (data.type == "Network Building") {
          if (!data.status_disable) {
            this.$store.dispatch("powerups/getDataTo", {
              data: data,
              user: this.user,
            });
          }
          this.validateForm.amount = 1;
          this.validateForm.share = false;
          this.validateForm.for = `network building and increasing the number of workplace relationships in ${time_period}`;
          this.validateForm.txtReward = " coin";
          this.validateForm.type = ["coin", "coin_amount"];
          this.validateForm.disAmount = false;
          this.validateForm.when = new Date();
        }else if(data.type == "Birthday") {

          this.$store.dispatch("powerups/getDataTo", {
              data: data,
              user: this.user,
            });
          
          this.validateForm.amount = 200;
          this.validateForm.share = false;
          this.validateForm.for = `being an amazing part of our team! We're celebrating you today and all the unique qualities you bring to our team. Here's to another year of growth, happiness, and success!
          Take time to enjoy your special day - you deserve it! 🎂`;
          this.validateForm.txtReward = " coin";
          this.validateForm.type = ["coin", "coin_amount"];
          this.validateForm.disAmount = false;
          this.validateForm.when = new Date();
          this.timePickerMock='9:00'

        }else if(data.type == "Work Anniversary") {

          this.$store.dispatch("powerups/getDataTo", {
              data: data,
              user: this.user,
            });
          
          this.validateForm.amount = 50;
          this.validateForm.share = false;
          this.validateForm.for = `another amazing year of making our team better every day. Happy Work Anniversary! 🌟`;
          this.validateForm.txtReward = " coin";
          this.validateForm.type = ["coin", "coin_amount"];
          this.validateForm.disAmount = false;
          this.validateForm.when = new Date();
          this.timePickerMock='9:00'
        }
        else {
          this.MasterType = true;
          this.$store.dispatch("powerups/getOptionToRecipient", this.user);
        }
        this.validateForm.path = data.path
        this.validateForm.sendType = data.typeList
      }
      this.onChangeAmountFunc();
      this.dialogCreateReward = true;
    },
    mockingMobileTextFor(text) {
      text = text.trim();
      text = text.split("[[time_period]]").join(" " + this.timeMocking + " ");
      if (text && text.length > 46) {
        return text.slice(0, 46) + " ... ";
      } else if (text) {
        return text;
      }
      return "reason for recognition";
    },
    mockingMobileTextTags(tag, i) {
      var tags = _.find(this.valuesOptional, { value: tag });

      if (tags&&i < 4) {
        return tags.label;
      } else if (tags&&i == 4) {
        return `+ ${this.validateForm.value.length - 4}`;
      }else if(!tags){
        return tag
      }
      return "";
    },
    saveChanges() {
      this.$store.dispatch("powerups/saveAuto", { form: this.validateForm, auto: this.dataAuto, time: this.timePickerMock, status: this.dataAuto.status });
      this.autoMatePopup = false;
      this.dialogCreateReward = false;
    },
    activateAutomation() {
      if(this.dataAuto&&!this.dataAuto.id){
        this.dataAuto.id=firebase.firestore().collection('powerups_schedule').doc().id
      }
      this.dataAuto.status=true
      this.$store.dispatch("powerups/saveAuto", { form: this.validateForm, auto: this.dataAuto, time: this.timePickerMock, status: true });

      this.autoMatePopupEdit = true;
    },
    deleteAutomation() {
      this.$store.dispatch("powerups/saveAuto", { form: this.validateForm, auto: this.dataAuto, time: this.timePickerMock, status: false });
      this.dataAuto.status=false
      this.autoMatePopupEdit = false;
    },
  }
};
</script>

<style lang="scss" scoped>
.powerup-table {
  display: flex;
  flex-wrap: wrap;
  margin-top: 25px;

  .powerup-card {
    width: 280px;
    height: 134px;
    display: grid;
    grid-template-columns: 100px auto;
    box-shadow: 0px 3px 6px #00000029;
    margin-bottom: 16px;

    .cover-image {
      height: 134px;
      width: 100px;
      background-repeat: no-repeat;
      background-color: rgba($color: #000000, $alpha: 0.1);
    }

    .card-title {
      padding-left: 10px;
      font-size: 15px;
      line-height: 16px;
      font-weight: 700;
    }
  }
}

.el-dropdown-link,
.el-icon-arrow-down,
.el-dropdown-menu__item {
  cursor: pointer;
  font-weight: 700;
  font-size: 13px;
  transition: 0.2s;
}

.el-dropdown {
  width: 100%;
}

.el-dropdown-link {
  color: rgba($color: #000000, $alpha: 0.6);
  width: calc(100% - 20px);
  padding: 4px 10px;
  border-radius: 100px;

  &:active,
  &:focus,
  &:hover {
    color: #6c30cc;
    background-color: rgba($color: #6c30cc, $alpha: 0.1);
  }
}

.el-dropdown-menu__item {
  color: rgba($color: #000000, $alpha: 0.8);
  min-width: 160px;
  padding: 0 16px;
  line-height: 28px;

  &:hover {
    color: #6c30cc;
  }
}

.el-dropdown-menu__item.is-disabled {
  color: rgba($color: #000000, $alpha: 0.4);
}

.txtBold14 {
  font-size: 14px;
  font-weight: 700;
  color: #4a4a4a;
}

.switch-contrainer-52 {
  width: 52px;
  height: 26px;

  .lable-checkbox {
    width: 50px;
    height: 24px;
  }

  .lable-checkbox:after {
    top: 2px;
    left: 3px;
    width: 19px;
    height: 19px;
  }
}

.txtRecipients {
  font-size: 12px;
  color: #6c30cc;
  text-decoration: underline;
  cursor: pointer;
}

.widthLabel {
  margin: 16px 0 8px 0;
  font-size: 16px;
  font-weight: 700;
  color: #4a4a4a;
}

.img-activityfeed {
  background-color: #6c30cc;
}

.imgScreenActivityfeed {
  position: absolute;
  width: 400px;
  height: 826px;
  margin: 16px;
}

.imgEmptyFeed {
  width: 342px;
}

.divEmptyFeed {
  display: flex;
  flex-direction: row;
  position: absolute;
  align-items: center;
  width: 324px;
  top: 44%;
  right: 13%;
  transition: 0.1s;

  .card {
    border-radius: 6px;
    box-shadow: 0px 4px 10px #00000020;
    width: 100%;

    .card-inner {
      border-radius: 6px 6px 0 0;
      background-color: #fff;
      padding: 20px 16px 12px;

      .user-profile {
        width: 32px;
        height: 32px;
        border-radius: 30px;
        background-color: #e5e5e5;
      }

      .text {
        width: 204px;
        margin-left: 12px;
        word-break: break-word;

        .tags {
          word-break: break-word;
          color: #00bcd4;
        }
      }
    }

    .card-footer {
      border-radius: 0 0 6px 6px;
      background-color: #ebebeb;
      height: 20px;
    }
  }
}

.hashtag-contriner {
  height: 34px;
  overflow: hidden;
  position: absolute;
  top: 40%;
  right: 9%;
  width: 340px;

  .hashtag-inner {
    position: absolute;
    flex-wrap: wrap;
    width: 500px;
  }

  .hashtag {
    background-color: #6db9de;
    margin-right: 6px;
    padding: 6px 12px;
    color: #fff;
    border: 1px solid #fff;
    border-radius: 20px;
    font-size: 12px;
    margin-bottom: 10px;
  }
}

.wordwrap {
  overflow: hidden;
  text-overflow: ellipsis;
  word-break: break-word;
}

.divEmptyFeed .wordwrap {
  max-height: 54px;
}

.RecipientsModalStyle {
  padding-top: 40px;
  padding-left: 40px;
  padding-bottom: 16px;
  background: #ffffff 0% 0% no-repeat padding-box;
  box-shadow: 0px 6px 6px #00000014;
  opacity: 1;
}

.divMembersRecipients {
  flex: 1;
  display: flex;
  flex-direction: column;
  padding-top: 24px;
  padding-bottom: 24px;
  margin-left: 16px;
  margin-right: 16px;
  overflow-y: auto;
  overflow-x: hidden;
  max-height: 55vh;
  cursor: pointer;
}

.rowDataStyle {
  display: flex;
  align-items: center;
  flex-direction: row;
  padding-top: 8px;
  padding-bottom: 8px;
}

.rowDataStyle:hover {
  background: #f5f5f5;
}

.columnDataStyle {
  padding: 0px 24px;
}

.imgProfile {
  width: 42px;
  height: 42px;
  background: #dbdbdb;
  border-radius: 21px;
}

.divProfile {
  display: flex;
  flex-direction: row;
  align-items: center;
}

.text-email {
  width: 200px;
}

.iconRemoveStyle {
  width: 22px;
  height: 22px;
  display: none;
}

.rowDataStyle:hover .iconRemoveStyle {
  display: inline-block;
}

.txtEllipsis {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.el-button--reset {
  background-color: #e0e0e0;
  border-color: #e0e0e0;
  height: 34px;
  font-size: 13px;
  font-weight: 700;
  color: #747474;
  padding: 9px 16px;
}

.el-button--reset:hover,
.el-button--reset:focus {
  background-color: #e0e0e0;
  border-color: #e0e0e0;
  color: #747474;
  opacity: 0.7;
}

.el-button--reset:active {
  color: #747474;
  background-color: #e0e0e0;
  border-color: #e0e0e0;
  opacity: 1;
}

.el-button--send {
  background-color: #32c2d5;
  border-color: #32c2d5;
  height: 34px;
  font-size: 13px;
  font-weight: 700;
  color: #ffffff;
  padding: 0px 16px 0px 12px;
}

.el-button--send:hover,
.el-button--send:focus {
  background-color: #32c2d5;
  border-color: #32c2d5;
  color: #ffffff;
  opacity: 0.7;
}

.el-button--send:active {
  color: #fff;
  background-color: #32c2d5;
  border-color: #32c2d5;
  opacity: 1;
}

.grid-2-sesstion {
  display: grid;
  grid-template-columns: 432px auto;
}

.grid-left {
  .header {
    background-color: #4e16a7;
    color: #fff;
    font-size: 18px;
    font-weight: 900;
    padding: 18px 40px;
  }
}

.grid-right {
  padding: 40px;
  background-color: #f8f8f8;
  padding-top: 55px;
}

.el-dropdown-menu {
  padding: 10px 0 0;
}

.switch-onoff {
  position: relative;
  width: 26px;
}

.switch-onoff-checkbox {
  display: none;
}

.switch-onoff-label {
  display: block;
  overflow: hidden;
  cursor: pointer;
  border: 1px solid #c3c3c3;
  border-radius: 20px;
  height: 12px;
}

.switch-onoff-inner {
  display: block;
  width: 200%;
  margin-left: -100%;
  transition: margin 0.3s ease-in 0s;
}

.switch-onoff-inner:before,
.switch-onoff-inner:after {
  display: block;
  float: left;
  width: 50%;
  height: 5px;
  padding: 0;
  line-height: 5px;
  font-size: 14px;
  color: white;
  font-family: Trebuchet, Arial, sans-serif;
  font-weight: bold;
  box-sizing: border-box;
}

.switch-onoff-inner:before {
  content: "";
  padding-left: 10px;
}

.switch-onoff-inner:after {
  content: "";
  padding-right: 10px;
  background-color: #eeeeee;
  color: #999999;
  text-align: right;
}

.switch-onoff-switch {
  display: block;
  width: 18px;
  height: 18px;
  margin: -5px;
  background: #888888;
  position: absolute;
  top: 3px;
  right: 20px;
  border-radius: 20px;
  box-shadow: 0px 0px 3px #00000029;
  transition: all 0.3s ease-in 0s;
}

.switch-onoff-checkbox:checked+.switch-onoff-label .switch-onoff-switch {
  right: 0px;
  background-color: #6c30cc;
}

.autogen-warning {
  background-color: rgba(#000000, 0.1);
  padding: 0px 30px;
  border-radius: 32px;
  height: 32px;
  color: #000;
  font-size: 13px;
}

.autogen-warning.active {
  color: #6C30CC;
  background-color: rgba(#6C30CC, 0.1);
}

.autogen-input {
  background-color: rgba(#000000, 0.06);
  color: rgba(#000000, 0.5);
  padding: 14px 24px;
  border-radius: 4px;
}

.autogen-input.recipients-style {
  height: 76px;
}

.autogen-input.schedule-style {
  height: calc(46px - 28px);
}

.custom-option {
  display: inline-block;
  /* Display el-option in a horizontal line */
  padding: 0px 6px;
}

.cssradio .el-radio__label {
  padding-left: 0px
}
</style>   
<style lang="scss">
#tabcreate {
  .el-cascader__tags .el-tag:not(.is-hit) {
    border-color: #6c30cc;
    background-color: #6c30cc24;
    color: #6c30cc;
    font-size: 15px;
    height: 30px;

    .el-tag .el-icon-close {
      background-color: #6c30cc;
      color: #6c30cc;
    }
  }

  .el-cascader__tags .el-tag .el-icon-close {
    background-color: #6c30cc;
    margin-top: 2px;
  }

  .el-cascader .el-input.is-focus .el-input__inner {
    border-color: #6c30cc;
  }

  .el-input__inner {
    height: 46px;

    &:focus {
      border-color: #6c30cc;
    }
  }

  .input-recipient {
    width: 100%;
  }

  .selcet-value {
    width: 100%;

    .el-tag.el-tag--info {
      background-color: #00bcd424;
      border-color: #00bcd4;
      color: #00bcd4;
      border-radius: 20px;
      font-size: 15px;
      font-weight: 700;
      padding: 4px 12px 8px;
      height: 30px;

      .el-tag__close {
        background-color: #00bcd4;
        color: #fff;
      }
    }
  }

  #typerecognition .el-input__inner::placeholder {
    color: #0a0a0a;
  }

  /* google */
  #typerecognition .el-input__inner::-webkit-input-placeholder {
    color: #0a0a0a;
  }

  /* firefox */
  #typerecognition .el-input__inner:-moz-placeholder {
    color: #0a0a0a;
  }

  /*ie*/
  #typerecognition .el-input__inner:-ms-input-placeholder {
    color: #0a0a0a;
  }



}
</style>
